export default function DrawerDivider() {
  return (
    <div
      className="bg-gray-200 dark:bg-gray-700 w-full"
      style={{ height: "1px" }}
    />
  );
}
